module.exports = __webpack_public_path__ + "img/step-4.c2d5914a.png";